/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlanRules/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import InstallmentLength from './InstallmentLength/index'
import MaxDiscount from './MaxDiscount/index'
import MinimumDownpayment from './MinimumDownpayment/index'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconRules from 'DesignSystem/Svgs/TysiaIconRules/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlanRules({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview/PlanRules"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="PlanRules.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="PlanRules.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Zet4Mv': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-2-Zet4Mv': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-3-Zet4Mv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Zet4Mv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PlanRules.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-Zet4Mv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconRules
  viewPath={`${viewPath}/TysiaIconRules`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 textTransform="uppercase"
 text="Plan Rules"
/>
</div>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../EditRules'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../EditRules'))}
 text="Edit"
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="PlanRules.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-1-Zet4Mv': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Zet4Mv': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-Zet4Mv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Zet4Mv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-5-Zet4Mv': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PlanRules.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Minimum Downpayment"
/>
<MinimumDownpayment
  viewPath={`${viewPath}/MinimumDownpayment`}
/>
</div>
<div
  data-testid="PlanRules.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Maximum installment length"
/>
<InstallmentLength
  viewPath={`${viewPath}/InstallmentLength`}
/>
</div>
<div
  data-testid="PlanRules.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Max discount"
/>
<MaxDiscount
  viewPath={`${viewPath}/MaxDiscount`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}